export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"hid":"description","name":"description","content":"marco "},{"hid":"keywords","name":"keywords","content":"marco"}],"link":[{"rel":"shortcut icon","href":"/favicon.ico"},{"rel":"icon","type":"image/svg+xml","href":"/favicon.svg"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/android-chrome-192x192.png"},{"rel":"icon","type":"image/png","sizes":"512x512","href":"/android-chrome-512x512.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"manifest","href":"/site.webmanifest"}],"style":[],"script":[{"id":"marco-product-direct-entry-back-fallback","innerHTML":"\n(function () {\n  try {\n    var path = window.location.pathname;\n    if (!/^\\/prod\\/(cat|m)\\//.test(path)) return;\n\n    var history = window.history;\n    if (!history || history.state && history.state.back) return;\n\n    var current = path + window.location.search + window.location.hash;\n    if (current === \"/\") return;\n\n    var state = history.state || {};\n    var position = typeof state.position === \"number\" ? state.position : history.length - 1;\n    history.replaceState(\n      Object.assign({}, state, {\n        back: state.back || null,\n        current: \"/\",\n        forward: current,\n        position: position,\n        replaced: typeof state.replaced === \"boolean\" ? state.replaced : true,\n        scroll: null,\n        marcoEarlyProductBackFallbackFor: current\n      }),\n      \"\",\n      \"/\"\n    );\n    history.pushState(\n      Object.assign({}, state, {\n        back: \"/\",\n        current: current,\n        forward: null,\n        position: position + 1,\n        replaced: false,\n        scroll: null,\n        marcoEarlyProductBackFallback: true\n      }),\n      \"\",\n      current\n    );\n  } catch (error) {\n  }\n})();\n","tagPriority":"critical","tagPosition":"head"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false